<template>
  <div class="loginDiaBox">
    <el-dialog title="" @close="clearDia"  @open="diaInit" center :visible.sync="diaShow" width="420px">
      <div class="titleBox">
        <svg class="svg_icon" aria-hidden="true" style="width: 50px; height: 50px">
          <use xlink:href="#iconLOGO"></use>
        </svg>
        <div style="height: 24px;">欢迎登录</div>
      </div>
      <div class="loginBox">
        <div class="errorMsg" v-if="isError">
          <img src="https://html.qiniu.jihelife.com/website/error_msg.png" alt="">
          账号或密码不正确，请重新输入
        </div>
        <div class="userNameBox">
          <div class="iconfont icondenglu-zhanghao leftIcon"></div>
          <input autoComplete="new-password" spellcheck="false" v-model="sendLoginMsg.username" type="text" placeholder="请输入账号">
        </div>
        <div class="passWardBox">
          <div class="iconfont icondenglumima leftIcon"></div>
          <input autoComplete="new-password" spellcheck="false" v-model="sendLoginMsg.password" type="password" placeholder="请输入密码">
        </div>
        <div class="loginStatus">
          <el-checkbox v-model="sendLoginMsg.keepLogin">保持登录状态</el-checkbox>
        </div>
        <!-- @click="login" -->
        <div class="loginBtn">登录</div>
        <div @click="clickRegister" class="registerClass">新商户注册</div>
      </div>
    </el-dialog>
    <registerDia v-if="registerShow" v-model="registerShow" />
  </div>
</template>
<script>
import registerDia from '@/components/registerDia';
import {
  userLogin
}from '@/api/api'
export default {
  components:{
    registerDia
  },
  data () {
    return {
      diaShow : this.value,
      sendLoginMsg : {
				keepLogin : false,
				username : '',
        password : '',
      },
      registerShow:false,
      isError:false,
    }
  },
  watch : {
		value(val){
			this.$emit('input',val);
			this.diaShow = val;
		},
		diaShow(val){
			this.$emit('input',val)
		}
  },
  props : {
		value : {
			type : Boolean,
			default : false
		},
	},
  methods:{
    clearDia() {
      console.log(888)
    },
    diaInit() {
      console.log(999)
    },
    clickRegister() {
      this.$emit('changeEvent')
      // this.$nextTick(() => {
      //   this.registerShow = true
			// })
    },
    // 登录
		login(){
        // 数值校验
			let {
          username,
          password
        } = this.sendLoginMsg
			let inputTest = /^[\s]*$/;  
			if (inputTest.test(username)){  
				this.isError = true;
				return  
			}
			if (inputTest.test(password)){  
				this.isError = true;
				return  
			}
        // 强转json
			let _p = this.sendLoginMsg;
			let _p_ = '';
			for(let key in _p){
				_p_ += `${key}=${_p[key]}&`
			}
			let msg = _p_.substring(0,_p_.length - 1)
			userLogin(msg).then(result => {
				console.log(result)
				let{
            status,
            data
          } = result;
				if(status == 200){
					if(data.sc == 0){
            this.isError = false;
						this.$router.push({ path : '/main'})
					}
					else{
						this.isError = true;
					}
				}
			})
		},

  }

}
</script>
<style lang="scss" scoped>
.loginDiaBox {
  color:red;
}
.titleBox {
   margin: 0 auto;
   font-size:20px;
   font-weight:600;
   color:rgba(72,72,72,1);
   display:flex;
   justify-content: center;
   align-items: center;
   margin-top: -35px;
   div {
     margin-left: 8px;
   }
 }
 .loginBox {
   width: 260px;
   margin: 0 auto;
   margin-top: 25px;
   .userNameBox {
     width: 260px;
     height: 50px;
     box-sizing: border-box;
     border-bottom: 1px solid #F2F2F2;
     display: flex;
     align-items: center;
   }
   .userNameBox:hover {
     border-bottom: 1px solid #ccc;
   }
   .passWardBox {
     width: 260px;
     height: 50px;
     box-sizing: border-box;
     border-bottom: 1px solid #F2F2F2;
     display: flex;
     align-items: center;
     margin-top: 10px;
   }
   .passWardBox:hover {
     border-bottom: 1px solid #ccc;
   }
   .leftIcon {
     width: 50px;
     padding-left: 10px;
     box-sizing: border-box;
     color: #ccc;
   }
   input {
     border: none;
     height: 46px;
     width: 210px;
     color: #484848;
   }
   input::-moz-placeholder{
      color:#ccc !important;
    }
   input::-webkit-input-placeholder{
      color:#ccc !important;
    }
    .loginStatus {
      color: #909090;
      margin-top: 20px;
      margin-bottom: 20px;
      font-size: 12px;
    }
    .loginBtn {
      width:260px;
      height:38px;
      line-height: 38px;
      background:linear-gradient(90deg,rgba(255,141,126,1) 0%,rgba(246,115,101,1) 100%);
      box-shadow:0px 10px 18px 0px rgba(253,125,111,0.1);
      border-radius:22px;
      font-weight:500;
      color:rgba(255,255,255,1);
      font-size: 14px;
      text-align: center;
      &:hover {
        background: #ed6758;
      }
    }
    .registerClass {
      font-size:12px;
      color:rgba(144,144,144,1);
      text-decoration: underline;
      text-align: center;
      margin-top: 20px;
      &:hover {
        color: #ed6758;
        cursor: pointer;
      }
    }
 }
 .errorMsg{
  // position: absolute;
  display: flex;
  font-size: 12px;
  color:#fd7d6f;
  // top:30px;
  // left: 40px;
  align-items: center;
  line-height: 30px;
  background:#fff4f2;
  width: 240px;
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 4px;
}
.errorMsg img{
  display: block;
  width: 12px;
  height: 12px;
  margin-right: 11px;
}
</style>
<style>
.loginDiaBox .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #fd7d6f;
    border-color: #fd7d6f;
}
.loginDiaBox .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #909090;
}
</style>


// WEBPACK FOOTER //
// src/components/loginDia.vue